import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from "src/app/services/app/shared-service/shared-data.service";
import { PaymentsService } from 'src/app/services/core/payments/payments.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import * as moment from 'moment-timezone';
import { timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-transactions-list',
  templateUrl: './transactions-list.component.html',
  styleUrls: ['./transactions-list.component.css']
})
export class TransactionsListComponent implements OnInit {
  transactions: any = [];
  transactionObj:any;
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any;
  status = true;
  user: any;
  todayDate:any = [];
  timeZone:any = timeZone;
  userPermission=UserPermission
  private readonly searchSubject = new Subject<string | undefined>();

  constructor(
     private route: ActivatedRoute,
     private paymentsService: PaymentsService,
     public permissionService: PermissionService,
     private sharedDataService: SharedDataService,
  ) { }

  ngOnInit() {
    this.getUser();
    this.listenSearch();

  }

  getUser() {
      this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
        if (data) {
          this.user = data;
          if (this.user.timeZone) {
            this.timeZone =  this.user.timeZone; 
  
          }
          this.todayDate = [
            moment().tz(this.timeZone).startOf("day"),
            moment().tz(this.timeZone).endOf("day"),
          ];
          this.getTransactions(this.currentPage);
        }
      });
  }

  getTransactions(page: number) {
    let queryparams: any = {
      limit: this.numberOfRecords,
      page,
      isActive: this.status,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      sortBy: 'createdAt:desc'

    }
    if(this.search){
      queryparams['search'] = this.search;
    }
    this.paymentsService
        .getTransactions(queryparams)
        .pipe(untilDestroyed(this)).subscribe((data: any) => {
          if (data && data.results) {
            this.transactions = data.results;
            this.totalPages = data.totalPages;
            this.totalResults = data.totalResults;
          }
        });
    

  }

 onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
     this.currentPage = 1;
    this.getTransactions(this.currentPage);
  }

  openRefundModal(transaction: any) {
    console.log("clicked")
    this.transactionObj = transaction
  }
  onPageChange(page: number) {
    this.currentPage = page;
    this.getTransactions(page);
  }

  onSearch(query: any) {
    if (query) {
      this.searchSubject.next(query);
    } else {
      this.currentPage = 1;
      this.getTransactions(this.currentPage);
    }
  }
  calculateProcessingAmount(transaction: any): number {
    return transaction?.processingFee?.length
      ? transaction.processingFee.reduce(
        (acc: number, fee: any) => acc + (fee.amountMoney?.amount || 0),
        0
      )
      : 0;
  }
  listenSearch() {
    this.searchSubject
      .pipe(debounceTime(500))
      .pipe(untilDestroyed(this)).subscribe((search) => {
        this.currentPage = 1;
        this.transactions = [];
        this.getTransactions(this.currentPage);
      });
  }


}
